import "components/Button/button.scss";

const Button = ({ children, className, disabled, ...props }) => {
  const buttonClass = `commonButton ${className} ${disabled ? "disabledButton" : ""}`;

  return (
    <button
      className={buttonClass}
      type="submit"
      {...props}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
